module.exports = __webpack_public_path__ + "img/dd-logo-mazda.f12fede5.png";